import {
  Children,
  PropsWithChildren,
  ReactElement,
  cloneElement,
  isValidElement,
  memo,
} from 'react';
import { useTheme } from 'styled-components/macro';
import { AvatarGroupProps } from './avatar.types';
import { Avatar } from './avatar';
import { StyledAvatarGroup } from './avatar.styled';

const AVATAR_GROUP_NAME = 'AvatarGroup';

export const AvatarGroup = memo(
  ({
    children,
    max = 0,
    size = 'm',
    avatarBorderColor = 'white',
  }: PropsWithChildren<AvatarGroupProps>) => {
    const validChildren = Children.toArray(children).filter(
      (child) => isValidElement(child) && child.type === Avatar
    ) as ReactElement<typeof Avatar>[];

    const theme = useTheme();
    const maxValue = Math.max(0, max);

    const visibleAvatars = maxValue
      ? validChildren.slice(0, maxValue)
      : validChildren;
    const hiddenCount =
      maxValue && validChildren.length > maxValue
        ? validChildren.length - maxValue
        : 0;

    return (
      <StyledAvatarGroup $size={size} $avatarBorderColor={avatarBorderColor}>
        {visibleAvatars.map((child, index) =>
          cloneElement(child, {
            key: index,
            size,
          } as Partial<typeof Avatar>)
        )}

        {hiddenCount > 0 && (
          <Avatar
            size={size}
            style={{
              background: theme.semantic.avatar.bg,
              color: theme.semantic.text.default,
            }}
          >{`+${hiddenCount}`}</Avatar>
        )}
      </StyledAvatarGroup>
    );
  }
);

AvatarGroup.displayName = AVATAR_GROUP_NAME;
